export default __webpack_public_path__ + "static/media/cp_geo_cu.0a499324.svg";